import * as Utils from "@/utils";
namespace Constants {
  export const LOGGER_DEV = window.localStorage.getItem("LOGGER_DEV") === "1";
  export const IS_DEV = import.meta.env.MODE === "dev";
  export const IS_DEBUG = import.meta.env.MODE !== "production";
  export const IS_USEDEBUG = Utils.getDebugFlag() === "1";
}

export default Constants;
